import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { getAllLocation, getAllTransferLocation } from "../../actions/warehouseAction";
import { DeleteOutlined } from "@ant-design/icons";
import { createTransfer, createTagWiseTransfer, createTransferItem, deleteTransferItem, getTransferItembyTransfernProduct, updateTransferItem, getTransferItem } from "../../actions/transfer";
import { updateVariation } from "../../actions/variableProductAction";
// import history from "../../history";
import { Link } from "react-router-dom";
import {
  ShoppingCartOutlined,
  PoweroffOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Skeleton,
  TreeSelect,
  Form,
  Affix,
  InputNumber,
  Button,
  message,
  Input,
} from "antd";
import AddtoTransfer from "./AddtoTransfer";

const SearchStock = ({
  Auth,
  getAllLocation,
  getAllTransferLocation,
  createTransfer,
  createTransferItem,
  updateVariation,
  deleteTransferItem,
  getTransferItembyTransfernProduct,
  updateTransferItem,
  createTagWiseTransfer,
  getTransferItem,
}) => {
  const [Loactions, setLoaction] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [refresh, setrefresh] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [reference, setReference] = useState("");

  const transfervoucher = useRef("")
  const To = useRef("");
  const From = useRef(Auth.profile.Office);
  const cartItems = useRef([]);
  var currentdate = new Date();
  var invoiceNumber =
    currentdate.getDate().toString() +
    (currentdate.getMonth() + 1).toString() +
    currentdate.getFullYear().toString() +
    currentdate.getHours().toString() +
    currentdate.getMinutes().toString() +
    currentdate.getSeconds().toString();
  useEffect(() => {
    // setrefresh(false);
    // console.log(cartItems);
    setLoading(false);
    calculateTotalQuantity()
  }, [refresh]);

  const calculateTotalQuantity = () => {
    const total = cartItems.current.reduce((sum, item) => sum + item.quantity, 0);
    setTotalQuantity(total);
  };

  useEffect(() => {
    getAllTransferLocation().then((result) => {
      // getAllLocation().then((result) => {
      setLoaction(result);
      setLoading(false);
    });
  }, []);
  if (Loading) {
    return <Skeleton active />;
  } else {
    return (
      <>
        <Row>
          <Col span={12} style={{ paddingTop: "10px", paddingRight: "10px" }}>

            <Affix>
              <AddtoTransfer
                cartItems={cartItems}
                setrefresh={setrefresh}
                refresh={refresh}
                setLoading={setLoading}
                from={From}
                Loactions={Loactions}
                transfervoucher={transfervoucher}
              />
            </Affix>
          </Col>

          <Col
            span={12}
            style={{
              padding: "30px",
              paddingTop: "10px",
              backgroundColor: "whitesmoke",
              borderRadius: "10px",
              minHeight: "85vh",
            }}
          >
            {transfervoucher.current != "" ?
            <Row style={{ textAlign: "center", marginBottom: "20px" }}>
              <Col span={24}>
                <h3>Total Quantity: {totalQuantity}</h3>
              </Col>
              <Col span={24} style={{marginBottom:"20px", color:"#706e6e"}}>
                <Link aria-current="page" to="/stock/transfer/history">
                  <Button type="danger" icon={<HomeOutlined />}>
                    Check Out
                  </Button>
                </Link>
              </Col>
            </Row> : null}


            {transfervoucher.current == "" ?
              <>
           
                <Row>
                  <Col style={{ width: "100%" }}>
                    <Form.Item name="Merchandiser" label="To">
                      <TreeSelect
                        treeData={Loactions}
                        onChange={(value) => {
                          To.current = value;
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ width: "100%" }}>
                    <Form.Item name="Reference" label="">
                      <Input
                        placeholder="Enter Title"
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  type="primary"
                  onClick={(e) => {
                    let promises = [];
                    if (From.current == "" || To.current == "") {
                      alert("Please insert all the required fields");
                    } else {
                      let formData = new FormData();
                      formData.append("tansfer_number", invoiceNumber);
                      formData.append("status", "Processing");
                      formData.append("source", From.current);
                      formData.append("destance", To.current);
                      formData.append("reference", reference);
                      formData.append("data", "");
                      createTransfer(formData).then((result) => {
                        transfervoucher.current = result;
                        setrefresh(!refresh)
                      });
                    }
                  }}
                >
                  Create a challan
                </Button>
                <Button
                  type="primary"
                  style={{marginLeft: "10px"}}
                  onClick={(e) => {
                    let promises = [];
                    if (From.current == "" || To.current == "") {
                      alert("Please insert all the required fields");
                    } else {
                      let formData = new FormData();
                      formData.append("tansfer_number", invoiceNumber);
                      formData.append("status", "Processing");
                      formData.append("source", From.current);
                      formData.append("destance", To.current);
                      formData.append("reference", reference);
                      formData.append("tag", 2)
                      formData.append("data", "");
                      createTagWiseTransfer(formData).then((result) => {
                        getTransferItem(result.id).then(res => {
                          for(let i=0;i<res.length;i++){
                            console.log(res[i])
                            const arr = {
                              id: res[i].Product[0].id,
                              title: res[i].Product[0].title,
                              product_code: res[i].Product[0].product_code,
                              size: res[i].Product[0].size,
                              quantity: res[i].quantity,
                              limit:  res[i].quantity,
                            };
                            cartItems.current.push(arr)
                          }
                          transfervoucher.current = result;
                          setrefresh(!refresh)
                        })
                        
                        
                      });
                    }
                  }}
                >
                  Create a Batch wise Challan
                </Button>
                
              </> :

              <Row className="Item-list-header" style={{ textAlign: "center" }}>
                <Col span={1}>
                  <h3>SL.</h3>
                </Col>
                <Col span={10}>
                  <h3>Product</h3>
                </Col>
                <Col span={6}>
                  <h3>Details</h3>
                </Col>
                <Col span={4}>
                  <h3>Quantity</h3>
                </Col>
                <Col span={3}>
                  <h3>Action</h3>
                </Col>
              </Row>
            }

            {cartItems.current.map((item, index) => {
              return (
                <Row className="Item-list" style={{ textAlign: "center" }}>
                  <Col span={1}>{index + 1}</Col>
                  <Col span={10}>{item.product_code}//{item.title}</Col>
                  <Col span={6}>
                    Attribute: {item.color}  {item.size}
                  </Col>
                  <Col span={4}>
                    <InputNumber
                      max={item.limit}
                      min={1}
                      value={item.quantity}
                      onChange={(value) => {
                        getTransferItembyTransfernProduct(transfervoucher.current.id, item.id).then(e => {
                          let formData = new FormData();
                          formData.append("quantity", value);
                          updateTransferItem(e[0].id, formData).then(e => {
                            message.success("Quantity has been added");
                            item.quantity = value;
                            calculateTotalQuantity();
                            setrefresh(!refresh)
                          })
                        })

                      }}
                    ></InputNumber>
                  </Col>
                  <Col span={3}>
                    <DeleteOutlined
                      style={{ color: "Red" }}
                      onClick={(e) => {
                        getTransferItembyTransfernProduct(transfervoucher.current.id, item.id).then(e => {
                          deleteTransferItem(e[0].id).then(() => {
                            message.success("Sucessfully removed");
                            cartItems.current.splice(index, 1);
                            calculateTotalQuantity();
                            setrefresh(!refresh)
                          });
                        });

                      }}
                    />
                  </Col>
                </Row>
              );
            })}

            <Divider />

            {/* Display the total quantity */}
            {/* {transfervoucher.current != "" ?
              <Row style={{ textAlign: "center", marginBottom: "20px" }}>
                <Col span={24}>
                  <h3>Total Quantity: {totalQuantity}</h3>
                </Col>
                <Col span={24} style={{marginBottom:"20px", color:"#706e6e"}}>
                  <Link aria-current="page" to="/stock/transfer/history">
                    <Button type="danger" icon={<HomeOutlined />}>
                      Check Out
                    </Button>
                  </Link>
                </Col>
              </Row> : null} */}


          </Col>
        </Row>
      </>
    );
  }
};

// for (const item of cartItems.current) {
//   formData = new FormData();
//   formData.append("transfer", result.id);
//   formData.append("product", item.id);
//   formData.append("quantity", item.quantity);
//   formData.append("is_received", false);
//   formData.append("data", "");
//   promises.push(createTransferItem(formData));
//   formData = new FormData();
//   formData.append("quantity", item.limit - item.quantity);
//   formData.append("data", "");
// }
// Promise.all(promises).then((e) => {
//   window.location.href = "/stock/transfer/history";
// })

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getAllLocation,
  getAllTransferLocation,
  createTransfer,
  createTransferItem,
  updateVariation,
  deleteTransferItem,
  getTransferItembyTransfernProduct,
  updateTransferItem,
  createTagWiseTransfer,
  getTransferItem,
})(SearchStock);
